import { createSlice } from '@reduxjs/toolkit';
import initialState from './bookedSessionFilterInitialState';
import {
  _setSubject,
  //_setSubjectIds,
  _setEarliestDate,
  _setLatestDate,
  _setAscending,
  _setIncludeCancelled,
} from './bookedSessionFilterAction';

export const bookedSessionFilterSlice = createSlice({
  name: 'delta/bookedSessionFilter',
  initialState,
  reducers: {
    setSubject: _setSubject,
    //setSubjectIds: _setSubjectIds,
    setEarliestDate: _setEarliestDate,
    setLatestDate: _setLatestDate,
    setAscending: _setAscending,
    setIncludeCancelled: _setIncludeCancelled,
    resetBookedSessionFilter: () => initialState,
  },
});

export const {
  setSubject,
  //setSubjectIds,
  setEarliestDate,
  setLatestDate,
  setAscending,
  setIncludeCancelled,
  resetBookedSessionFilter,
} = bookedSessionFilterSlice.actions;

export default bookedSessionFilterSlice.reducer;
